module.exports = __webpack_public_path__ + "img/MG_4687R-scaled.06430688.jpg";